import { createAsyncActionConstants } from 'utilities/util'

export const TYPES = {
	FETCH_EXCEPTIONS: createAsyncActionConstants('FETCH_EXCEPTIONS'),
	FETCH_NOTIFICATIONS: createAsyncActionConstants('FETCH_NOTIFICATIONS'),
	RESET_NOTIFICATIONS: createAsyncActionConstants('RESET_NOTIFICATIONS'),
	UPDATE_NOTIFICATIONS: createAsyncActionConstants(
		'UPDATE_NOTIFICATIONS'
	),
	FETCH_LOGS: createAsyncActionConstants('FETCH_LOGS'),
	FETCH_REPROCESS: createAsyncActionConstants('FETCH_REPROCESS'),
	RESET_REPROCESS: createAsyncActionConstants('RESET_NOTIFICATIONS'),
	REPROCESS: createAsyncActionConstants('REPROCESS'),
	FILE: createAsyncActionConstants('FILE'),
	TOGGLE_REPROCESS: createAsyncActionConstants('TOGGLE_REPROCESS'),
}
